import isEmpty from 'lodash/isEmpty';
import { observer } from 'mobx-react-lite';
import EmptyNotifications from 'molecules/Notifications/EmptyNotifications';
import NotificationFooter from 'molecules/Notifications/NotificationFooter';
import NotificationList from 'molecules/Notifications/NotificationList';
import React, { useEffect } from 'react';
import { useStore } from 'stores/store';
import { useDirectNotificationApi } from 'utils/hooks/useDirectNotificationApi';

import s from '../Notifications.module.scss';

const DirectNotifications = ({ unread }: { unread?: boolean }) => {
  const { NotificationStore } = useStore();
  const { onLoadMore, onNavigate, setUnread, setReadAll, onToggleUnread, isLoading } =
    useDirectNotificationApi({
      unread
    });

  useEffect(() => {
    setUnread(unread);
  }, [unread, setUnread]);

  const showLoading = isLoading && isEmpty(NotificationStore.directMessages);
  const hasMore =
    !isEmpty(NotificationStore.directMessages) &&
    NotificationStore.directMessages.length <
      (unread ? NotificationStore.unreadDirectCount : NotificationStore.totalDirectCount);

  return (
    <div className={s.Notifications}>
      {!isEmpty(NotificationStore.directMessages) ? (
        <NotificationList
          onNavigate={onNavigate}
          onToggleUnread={onToggleUnread}
          items={NotificationStore.directMessages}
        />
      ) : (
        <EmptyNotifications isLoading={showLoading} />
      )}
      <NotificationFooter onLoadMore={onLoadMore} setReadAll={setReadAll} />
    </div>
  );
};

export default observer(DirectNotifications);
